module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjkwMjcgMTAuNjU0N0wyMS4zNDgyIDJIMTkuNTgzOEwxMy4xMTg5IDkuNTE0NzhMNy45NTU0NyAySDJMOS44MDgyIDEzLjM2MzdMMiAyMi40Mzk1SDMuNzY0NDNMMTAuNTkxNSAxNC41MDM2TDE2LjA0NDUgMjIuNDM5NUgyMkwxMy45MDI3IDEwLjY1NDdaTTExLjQ4NjEgMTMuNDYzOEwxMC42OTUgMTIuMzMyMkw0LjQwMDE4IDMuMzI4MjRINy4xMTAyNUwxMi4xOTAyIDEwLjU5NDdMMTIuOTgxMyAxMS43MjYzTDE5LjU4NDcgMjEuMTcxN0gxNi44NzQ2TDExLjQ4NjEgMTMuNDYzOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-x-black.svg
// module id = t92W
// module chunks = 1